import { ProviderType } from '../../gql/types';

// Shared, human-readable labels for the contract's ProviderType enum. Used wherever a provider
// is rendered (health board, routing-policy order, override editor) so the wording is consistent.

export const PROVIDER_LABEL: Record<ProviderType, string> = {
  [ProviderType.InHouse]: 'In-House',
  [ProviderType.Openai]: 'OpenAI',
  [ProviderType.Anthropic]: 'Anthropic',
  [ProviderType.Gemini]: 'Gemini',
  [ProviderType.Openrouter]: 'OpenRouter',
};

/** Canonical ordering used to offer providers for selection (in-house first). */
export const PROVIDER_TYPES: ProviderType[] = [
  ProviderType.InHouse,
  ProviderType.Openai,
  ProviderType.Anthropic,
  ProviderType.Gemini,
  ProviderType.Openrouter,
];

export function providerLabel(type: ProviderType): string {
  return PROVIDER_LABEL[type] ?? type;
}
